module.exports = __webpack_public_path__ + "08e36c1d8c886cb95ea9f871f46e4278.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/game-owl-s.png
// module id = 2034
// module chunks = 0